exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "#resolve-conflict-dialog{min-width:800px}#resolve-conflict-dialog textarea{resize:none !important;overflow:hidden !important}\n", ""]);

